module.exports = __webpack_public_path__ + "img/endpoint-security-products-features.dcb6cecf.png";